import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './InsertorSecurityComponent.css';
import _ from 'lodash';
import InsertCertificate from './insertCertificate/InsertCertificate.container';

class InsertorSecurityComponent extends Component {
    render() {
        return (
            <div className='insertor-security-container'>
                <h4 className='page-label'>
                    {_.get(this.props.translation, 'security.label')}
                </h4>
                <div className="info-container">
                    <span>{_.get(this.props.translation, 'security.inserter_info_part_1')}</span>
                    <br/>
                    <br/>
                    <span>{_.get(this.props.translation, 'security.inserter_info_part_2')}</span>
                    <br/>
                    <br/>
                    <span>{_.get(this.props.translation, 'security.inserter_info_part_3')}</span>
                    <br/>
                    <br/>
                    <span>{_.get(this.props.translation, 'security.inserter_info_part_4')}</span>
                </div>
                <InsertCertificate />
            </div>
        );

    }
}

InsertorSecurityComponent.propTypes = {
    translation: PropTypes.object,
};

export default InsertorSecurityComponent;



// WEBPACK FOOTER //
// ./src/components/securityManagement/insertorSecurityComponent/InsertorSecurityComponent.js